import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BaseComponent } from '@core/components/base-component';
import { DepartmentPickerItem } from './shared/department-picker-item';
import { DepartmentPickerService } from './shared/department-picker.service';

@Component({
  selector: 'pop-department-picker',
  templateUrl: './department-picker.component.html',
  styleUrls: ['./department-picker.component.less']
})
export class DepartmentPickerComponent extends BaseComponent implements OnInit {
  public allDepartments: DepartmentPickerItem[];
  public departments: DepartmentPickerItem[];

  @Input()
  public styleClass: 'rem-fix' | '' = '';

  private _selectedDepartment: DepartmentPickerItem;
  @Input()
  public get selectedDepartment() {
    return this._selectedDepartment ?? undefined;
  }
  public set selectedDepartment(value: DepartmentPickerItem) {
    if (value === null) value = undefined;
    if (this._selectedDepartment !== value) {
      this._selectedDepartment = value;
      this.selectedDepartmentChange.emit(value);
    }
  }

  private _departmentFilter: (project: DepartmentPickerItem) => boolean;
  @Input()
  public get departmentFilter() {
    return this._departmentFilter;
  }
  public set departmentFilter(value: (project: DepartmentPickerItem) => boolean) {
    this._departmentFilter = value;
    this.filter();
  }

  @Output()
  public selectedDepartmentChange = new EventEmitter<DepartmentPickerItem | undefined>();

  public constructor(private departmentPickerService: DepartmentPickerService) {
    super();
  }

  public async ngOnInit() {
    const departments = await this.departmentPickerService.getDepartments();

    this.allDepartments = departments.map(d => {
      return new DepartmentPickerItem(d); // avoid stackoverflow in prime ng equals by value
    });

    this.filter();
  }

  private filter() {
    if (this.departmentFilter) {
      this.departments = this.allDepartments?.filter(d => {
        return this.departmentFilter(d);
      });
    } else {
      this.departments = this.allDepartments;
    }
  }
}
